import { render, staticRenderFns } from "./BHint.vue?vue&type=template&id=26003f3c&scoped=true&"
import script from "./BHint.vue?vue&type=script&lang=js&"
export * from "./BHint.vue?vue&type=script&lang=js&"
import style0 from "./BHint.vue?vue&type=style&index=0&id=26003f3c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26003f3c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
